import { requestBuilder } from '../../../http/RequestBuilder';
import type { MembershipDetails } from '../../entityTypes';
import { useRefetchMembershipDetailsMutationOptions } from './useRefetchMembershipDetailsMutationOptions';

export interface MembershipGuidanceNotes {
    id: string;
    membershipId: string;
    notes: string | null;
    createdAt: string;
    updatedAt: string | null;
}

export interface UpsertMembershipGuidanceNotesBody {
    membershipId: string;
    notes: string | null;
}

const useUpsertMembershipGuidanceNotes = requestBuilder.mutation<
    MembershipGuidanceNotes,
    UpsertMembershipGuidanceNotesBody
>({
    endpoint: () => '/api/admin/membership-guidance-notes',
    method: 'POST',
});

export const useUpsertMembershipGuidanceNotesAndRefetch = (
    membership: MembershipDetails | null,
) => {
    const refetchMembershipMutationOptions =
        useRefetchMembershipDetailsMutationOptions(membership);

    const { mutateAsync, isPending } = useUpsertMembershipGuidanceNotes(
        refetchMembershipMutationOptions,
    );

    const upsertMembershipGuidanceNotesAsync = async (
        body: UpsertMembershipGuidanceNotesBody,
    ) => {
        return await mutateAsync({
            body,
        });
    };

    return {
        upsertMembershipGuidanceNotesAsync,
        isPending,
    };
};
